import { css } from 'styled-components';
import { tombac } from './tombac';
export const textStyles = css(["", ";"], _ref => {
  let {
    $color,
    altFont,
    ...props
  } = _ref;
  return altFont ? tombac.altText({
    ...props,
    color: $color,
    withDefaults: false
  }) : tombac.text({
    ...props,
    color: $color,
    withDefaults: false
  });
});
//# sourceMappingURL=textStyles.js.map